/* Zwevende shopknop: verschijnt na de hero, verdwijnt bij de footer. */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('sticky-shop')) return;
  customElements.define('sticky-shop', class extends HTMLElement {
    connectedCallback() {
      var self = this, tick = false;
      this.hidden = false;
      function update() {
        tick = false;
        var f = document.querySelector('footer');
        var nearFooter = f && f.getBoundingClientRect().top < window.innerHeight;
        self.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.9 && !nearFooter);
      }
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }
  });
})();
